import React from 'react';
import Content from '@/components/foundations/content';
import { StaticImage } from 'gatsby-plugin-image';
import * as styles from './problem.module.scss';
import OmgSvg from '@/svgs/handwriting/omg';
import KanjiOnayamiSvg from '@/svgs/handwriting/onayamikanji';
import ArrowSvg from '@/svgs/handwriting/arrow';

const ProblemContent: React.FC = () => {
  return (
    <>
      <h2>
        こんな<strong>課題</strong>、<br className="sp" />
        ありませんか？
      </h2>
      <ul className={styles.oProblem__list}>
        <li>
          <dl>
            <dd>システムの操作に時間がかかっている</dd>
          </dl>
        </li>
        <li>
          <dl>
            <dd>使用方法や操作に関する問い合わせが多い</dd>
          </dl>
        </li>
        <li>
          <dl>
            <dd>サイトの訪問者は多いがCVにつながらない</dd>
          </dl>
        </li>
        <li>
          <dl>
            <dd>ユーザーの評価が低いが改善点が分からない</dd>
          </dl>
        </li>
      </ul>
      <dl className={styles.oProblem__decorationCharactor}>
        <dt>
          <OmgSvg />
        </dt>
        <dd>
          <StaticImage src="./img/omg.png" alt="こんな課題、ありませんか？" />
        </dd>
      </dl>
      <dl className={styles.oProblem__decorationOnayami}>
        <dt>
          <KanjiOnayamiSvg />
        </dt>
        <dd>
          <ArrowSvg />
        </dd>
      </dl>
    </>
  );
};

const Problem: React.FC<{ setScroll: Function }> = ({ setScroll }) => {
  return (
    <Content
      className={{ wrapper: styles.oProblem, inner: styles.lContent__inner }}
      intersection={{ visible: styles.visible, standby: styles.standby, callback: setScroll }}
    >
      <ProblemContent />
    </Content>
  );
};

export default Problem;
